<template>
  <div class="c-knowledge-overview">
    <div class="overview-head">
      <div class="overview-head__num">01</div>
      <div class="overview-head__title">学习成果统计</div>
    </div>
    <ul class="overview-list">
      <li class="overview-list__item"  v-for="(item,index) in testOverviewlist"
      :key="`testItem_${index}`">
        <div :class="item.bgClass" class="overview-list__bg">
          <div v-if="item.id === 0">
            <div class="week">{{week}}</div>
            <div class="daytime">{{dayTime}}</div>
          </div>
        </div>
        <div>
          <div class="item-status">
            {{item.title}}
          </div>
          <div class="item-num">
            {{item.num}} <span class="item-num__total">{{overviewInfo.total_stu}}</span>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { getClassLearningOutcomes } from '@/api/pt';

export default {
  name: 'KnowledgeOverview',
  props: {
    overviewData: {
      type: Object,
      default: () => {},
    },
    classType: {
      type: [String, Number],
      default: '',
    },
    classId: {
      default: '',
    },
    masterClassId: {
      default: '',
    },
  },
  data() {
    return {
      activeIndex: 'one',
      overviewInfo: {},
      testOverviewlist: [
        {
          title: '班级学习天数', num: '', bgClass: 'complete', id: 0,
        },
        {
          title: '总答题数', num: '', bgClass: 'average', id: 1,
        },
        {
          title: '平均正确率', num: '', bgClass: 'correct', id: 2,
        },
      ],
      week: '',
      dayTime: '',
    };
  },
  watch: {
    classId() {
      this.getClassLearningOutcomes();
    },
  },
  computed: {
  },
  mounted() {
    const getDay = dayjs(new Date());
    this.dayTime = getDay.$D;
    const a = ['日', '一', '二', '三', '四', '五', '六'];
    const str = `星期${a[getDay.$W]}`;
    this.week = str;
    this.getClassLearningOutcomes();
  },
  methods: {
    async getClassLearningOutcomes() {
      const userInfo = JSON.parse(localStorage.getItem('CRM_USER_INFO')) || {};
      const res = await getClassLearningOutcomes({
        class_id: this.classId,
        school_id: userInfo.campusId,
        school_master_class_id: this.masterClassId,
      });
      this.testOverviewlist[0].num = `${res.data.study_days}天`;
      this.testOverviewlist[1].num = `${res.data.question_num}道`;
      if (Number(res.data.avg_right_rate) !== -1) {
        this.testOverviewlist[2].num = `${Math.floor(res.data.avg_right_rate * 100)}%`;
      } else {
        this.testOverviewlist[2].num = '--';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.c-knowledge-overview{
  .overview-head{
    display: flex;
    padding:45px 0 0 19px;
    align-items: center;
    &__num{
      font-size: 22px;

      font-weight: bold;
      color: rgba(0, 0, 0, 0.8);
      margin-right: 14px;
      background:url('~@/views/pt/images/class_bg.png');
      background-size:cover;
      width:38px;
      height:29px;
      line-height: 29px;
      text-align: center;
    }
    &__title{
      font-size: 17px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);
    }
  }
  .overview-list{
    display: flex;
    justify-content: space-between;
    margin:18px 18px 0 0;
    padding-left: 20px;
    &__bg {
      margin: 25px;
      width: 90px;
      height: 90px;
    }
    .complete{
      background: url('~@/views/pt/images/class_day.png') #F0F2F8 no-repeat top left / contain;
    }
    .average{
      background: url('~@/views/pt/images/total_number.png') #F0F2F8 no-repeat top left / contain;
    }
    .correct{
      background: url('~@/views/pt/images/answer_true.png')
      #F0F2F8 no-repeat top left / contain;
    }
    &__item{
      // 兼容样式处理
      background-size:cover;
      display: flex;
      width: 340px;
      height: 146px;
      border-radius: 12px;
      text-align: right;
      background-color: #F0F2F8;
      .item-status{
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #808BAA;
        padding: 30px 0 0 40px;
        margin-bottom: 10px;
      }
      .item-num{
        font-size: 26px;
        padding-top: 15px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #1989FA;
        letter-spacing: 1px;
        margin-bottom: 20px;
        &__total{
          font-size:1.8vw;
        }
      }
      .item-max {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 20px;
        padding-top: 20px;
      }
      .item-link{
        // font-size: 14px;
        font-size:.9vw;
        padding-left:2.8vw;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        text-decoration:underline;
        &:hover{
          cursor: pointer;
        }
      }
    }
  }

 }
 .detail-float{
   overflow: auto;
   .float-item{
    float: left;
    width: 50%;
    font-size:12px;
    font-family: PingFangSC-Medium, PingFang SC;
    text-align: center;
   }
 }

.el-popover.popover-top{
  margin-top:30px;
}
.week {
  margin-top: 23px;
  font-size: 10px;
  text-align: center;
  color: #fff;
}
.daytime {
  line-height: 30px;
  text-align: center;
  font-size: 16px;
  color: #E25656;
}
</style>
